import * as React from 'react';
import { useAccountOrderLml2Description } from '../../hooks';
import { ActorApiStringDisplay } from '../../../../../../components/display/string';

export const AccountOrderLml2Description = () => {
  const {
    data,
    isLoading,
    error,
  } = useAccountOrderLml2Description();
  return (
    <ActorApiStringDisplay
      data={data}
      isLoading={isLoading}
      error={error}
    />
  );
};
